import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSupplierForm from "../../forms/CreateOrUpdateSupplierForm";
import { SupplierResponseDto } from "../../shared/dtos/supplier/SupplierResponseDto";

interface UpdateSupplierModalProps {
  open: boolean;
  onClose: () => void;
  supplier: SupplierResponseDto | null;
  loading: boolean;
  error: string | null;
}

const UpdateSupplierModal: React.FC<UpdateSupplierModalProps> = ({
  open,
  onClose,
  supplier,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${supplier?.name || ""}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateSupplierForm
      isEditing={true}
      supplier={supplier}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateSupplierModal;
